// Clevertap stuff
import { getCookie, resolveKeysInObjectsArrays, isEmpty, isUserSignedIn, isCtUser, getUserAuthValues } from 'utils/browserHelper'
import ClevertapReact from './clevertap'
import { v4 as uuidv4 } from 'uuid'
import { sendS2SEvent } from 'api/flights/results'
const CLEVERTAP_KEY = process.env.CT_PUBLIC_CLEVERTAP_KEY || ''
const getuuid = () => {
    if(typeof localStorage !== undefined){
        if(localStorage.getItem('uuid')){
            return localStorage.getItem('uuid')
        }
        const uid = uuidv4();
        localStorage.setItem('uuid',uid);
        return uid;
    }
    return uuid()
}
class Clevertap {
    constructor() {
        this.enabled = false
        if (CLEVERTAP_KEY) {
            this.enabled = true
            ClevertapReact.initialize(CLEVERTAP_KEY)
        }
    }

    event = (name, payload = {}) => {
        try {
            if (this.enabled) {
                const whiteListEventNames = ['Charged', 'Air_PageLoad', 'Air_UI_Action']
                const { userId } = getUserAuthValues()
                const domain = resolveKeysInObjectsArrays(['location', 'hostname'], window)
                const ctAb = isEmpty(getCookie('ct-ab')) ? {} : JSON.parse(decodeURIComponent(getCookie('ct-ab')))
                payload.platform = 'DESKTOP'
                payload.domainName = domain || 'NA'
                payload.isCtLoginUser = isCtUser()
                payload.is_logged_in = isUserSignedIn() ? 'yes' : 'no'
                payload.userId = userId || 'NA'
                payload.fareFamily_abcookie = ctAb.fareFamily || 'N/A'
                payload.ab_sameprice = ctAb?.sameprice|| 'N/A'
                payload.ab_fare_cal_tab = ctAb?.fare_cal_tab || 'N/A'
                payload.ctNewFlow_abCookie = getCookie('abtest') || 'N/A'

                setTimeout(() => {
                    if (whiteListEventNames.includes(name)) {
                        const s2sPayload = {
                            id: getuuid(),
                            schemaName: `userEvents.${name.toLowerCase()}`,
                            schemaVersion: '0.1',
                            timestamp: new Date().getTime(),
                            tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
                            data: payload
                        }
                        sendS2SEvent(s2sPayload)
                    }
                    ClevertapReact.event(name, payload)
                }, 300)
            }
        } catch (e) {
            console.error(e)
        }
    }

    profile = payload => {
        if (this.enabled) {
            ClevertapReact.profile(payload)
        }
    }

    logout = () => {
        if (this.enabled) {
            ClevertapReact.logout()
        }
    }
}

const ClevertapObject = new Clevertap()
export default ClevertapObject
